export function getAppEmailTemplate(type,firstName,lastName,projectName,
                                    senderVorname,senderNachname){
    if (type==="Stunden-Anmeldung")
    {
        return `Hallo ${firstName +" "+lastName}, \n\n` +
            `für das Projekt ${projectName} übersende ich Ihnen eine Anmeldung zur Stundenlohnarbeit. \n` +
            "\n" +
            "Falls noch keine Beauftragung erfolgt ist, senden Sie uns das Dokument bitte unterschrieben zurück.\n" +
            "\n" +
            `Bitte verwenden Sie den folgenden Link, um das Dokument zu öffnen: \n`
    }
    else if (type==="Stunden-Abmeldung")
    {
        return `Hallo ${firstName +" "+lastName}, \n` +
            `für das Projekt ${projectName} übersende ich Ihnen die (Teil)Abmeldung der beauftragten Stundenlohnarbeiten. \n` +
            "\n" +
            "Bitte verwenden Sie den folgenden Link, um das Dokument zu öffnen: \n" +
            "{url} \n" +
            "Viele Grüße,\n" +
            `${senderVorname + ","+ senderNachname}`
    }

    else if (type==="Tages")
    {
        return `Hallo, \n` +
       `Hier ist der Link zur Dokumentation des Projekts ${projectName}` + "\n" +
        "Bitte verwenden Sie den folgenden Link, um das Dokument zu öffnen: \n" +
        "{url} \n" +
        "Viele Grüße,\n" +
        `${senderVorname + ","+ senderNachname}`
    }

}



/*
export function getAppEmailTemplate(type,firstName,lastName,projectName,
                                    senderVorname,senderNachname){
    if (type==="Stunden-Anmeldung")
    {
        return `Hallo ${firstName +" "+lastName}, \n\n` +
            `für das Projekt ${projectName} übersende ich Ihnen eine Anmeldung zur Stundenlohnarbeit. \n` +
            "\n" +
            "Falls noch keine Beauftragung erfolgt ist, senden Sie uns das Dokument bitte unterschrieben zurück.\n" +
            "\n" +
            "Bitte verwenden Sie den folgenden Link, um das Dokument zu öffnen: \n" +

            "{url} \n" +

            "Viele Grüße,\n" +
            `${senderVorname + ","+ senderNachname}`
    }
    else if (type==="Stunden-Abmeldung")
    {
        return `Hallo ${firstName +" "+lastName}, \n` +
            `für das Projekt ${projectName} übersende ich Ihnen die (Teil)Abmeldung der beauftragten Stundenlohnarbeiten. \n` +
            "\n" +
            "Bitte verwenden Sie den folgenden Link, um das Dokument zu öffnen: \n" +
            "{url} \n" +
            "Viele Grüße,\n" +
            `${senderVorname + ","+ senderNachname}`
    }

    else if (type==="Tages")
    {
        return `Hallo, \n` +
       `Hier ist der Link zur Dokumentation des Projekts ${projectName}` + "\n" +
        "Bitte verwenden Sie den folgenden Link, um das Dokument zu öffnen: \n" +
        "{url} \n" +
        "Viele Grüße,\n" +
        `${senderVorname + ","+ senderNachname}`
    }

}
*/
